var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrapper"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"titleBox mb-5"},[_vm._v(" Настройки CRM ")]),(_vm.activeComponent)?_c(_vm.activeComponent,{tag:"component"}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }